export default __webpack_public_path__ + "static/media/videoBnr.e40ed2c1.png";